import { render, staticRenderFns } from "./shareboard.vue.html?vue&type=template&id=a1930720&scoped=true"
import script from "./shareboard.controller?vue&type=script&lang=js&external"
export * from "./shareboard.controller?vue&type=script&lang=js&external"
import style0 from "./shareboard.vue.html?vue&type=style&index=0&id=a1930720&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1930720",
  null
  
)

export default component.exports